import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaExclamation } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  onConfirm: () => void;
}

export function ModalCertezaCancelarLote({
  show,
  handleClose,
  onConfirm,
}: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Cancelar lote"
      centered={true}
      footer={true}
      footerConfirmButton={true}
      onConfirm={onConfirm}
      confirmButtonText="Sim"
      cancelButtonText="Não"
    >
      <ModalBody>
        <Icone>
          <FaExclamation />
        </Icone>
        Deseja cancelar a criação do lote?
      </ModalBody>
    </ModalCustom>
  );
}
